//#region Libraries
import styled from "styled-components";
//#endregion

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    & span {
        font-size: 14px;
    }
`;